import React, { useLayoutEffect, useState } from "react";

import { debounce } from "lodash";

// eslint-disable-next-line func-style
function useResize<R>(ref: React.RefObject<R>) {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }

    const handleResize = () => {
      if (!((ref.current as unknown) as HTMLElement)?.offsetWidth) {
        return;
      }

      setWidth(((ref.current as unknown) as HTMLElement).offsetWidth);
      setHeight(((ref.current as unknown) as HTMLElement).offsetHeight);
    };

    window.addEventListener("resize", debounce(handleResize, 500));

    return () => {
      window.removeEventListener("resize", debounce(handleResize, 500));
    };
  }, [ref]);

  return { width, height };
}

export default useResize;
